import { Injectable } from '@angular/core';
import { ActivityStatus, ActivityStudentAnswers, FeatureName, InputAnswer, Tags } from '@tekman/onmat/models';
import { Subject } from 'rxjs';

@Injectable()
export class TekinputService {
  private isEditingInput: Subject<boolean> = new Subject<boolean>();
  isEditingInput$ = this.isEditingInput.asObservable();

  setIsEditingInput(isEditing: boolean) {
    this.isEditingInput.next(isEditing);
  }

  parseTekinput(
    htmlStatement: string,
    isTeacher: boolean,
    studentAnswers: ActivityStudentAnswers,
    isValidated: boolean,
    tags: Tags[],
    status: ActivityStatus,
    display: boolean,
    isTry: boolean
  ): string {
    return htmlStatement.replace(/(<tekinput.*?>)(.*?)(<\/tekinput.*?>)/g, (match, inputType) =>
      this.tekInputReplacer(inputType, isTeacher, studentAnswers?.inputs, isValidated, tags, status, studentAnswers?.sentAt, display, isTry)
    );
  }

  private tekInputReplacer(
    inputType: string,
    isTeacher: boolean,
    studentAnswers: InputAnswer[],
    isValidated: boolean,
    tags: Tags[],
    status: ActivityStatus,
    sentAt: Date | string,
    display: boolean,
    isTry: boolean
  ): string {
    const orderTekarea = +inputType.match(/(order=".*?")/g)[0].split('"')[1];
    const inpuStudentAnswer = studentAnswers?.find(input => +input.order === orderTekarea);
    const isDisabled = isTeacher ? true : isValidated;
    const isEvaluable = !!tags?.find(tag => tag.name === FeatureName.IS_EVALUABLE)?.value;
    const isSelfCorrecting = !!tags?.find(tag => tag.name === FeatureName.IS_SELFCORRECTING)?.value;
    const isActivityAssesed = status === ActivityStatus.ASSESSED;

    const attributes = [
      `[isTry]="${isTry}"`,
      `[isTeacher]="${isTeacher}"`,
      `[disabled]="${(sentAt !== null && sentAt !== undefined) || isDisabled}"`,
      `[validated]="${isTeacher ? isValidated : isValidated || (sentAt !== null && sentAt !== undefined)}"`,
      `[isSelfCorrecting]="${isSelfCorrecting || (!isSelfCorrecting && isActivityAssesed && isEvaluable)}"`,
    ];

    if (inpuStudentAnswer) {
      if (inpuStudentAnswer.value !== null && inpuStudentAnswer.value !== undefined && display) {
        attributes.push(`value="${inpuStudentAnswer.value}"`);
      }
      attributes.push(`[isCorrect]="${inpuStudentAnswer.isCorrect === true}"`);
    }

    attributes.push(`></tekinput>`);

    inputType = inputType.slice(0, -1).concat(attributes.join(' '));
    return inputType;
  }
}
